module.exports = require('./emitOptimisticQueryDataUpdate')
